export default __webpack_public_path__ + "static/media/image18tum.e099ff99.jpg";